import { render } from "./WhatMadeExtraordinary.vue?vue&type=template&id=13a80849&ts=true"
import script from "./WhatMadeExtraordinary.vue?vue&type=script&lang=ts"
export * from "./WhatMadeExtraordinary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__